<script setup lang="ts">
import { TuiColorInput } from "@vm/tui";
import { useForm } from "@vm/vue-core";

import type { ComparisonSettings } from "../use-settings-editor-store";

const { formData } = useForm<ComparisonSettings>();
</script>

<template>
  <div class="space-y-4">
    <h2 class="text-lg font-medium text-gray-900">Background colors</h2>
    <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
      <TuiColorInput
        v-model="formData.colors.headerBackground"
        label="Header background"
        full-path="colors_headerBackground"
      />
      <TuiColorInput
        v-model="formData.colors.accordionHeaderBackground"
        label="Accordion header background"
        full-path="colors_accordionHeaderBackground"
      />
      <TuiColorInput
        v-model="formData.colors.subjectRowBackground"
        label="Subject row background"
        full-path="colors_subjectRowBackground"
      />
      <TuiColorInput
        v-model="formData.colors.referenceRowBackground"
        label="Reference row background"
        full-path="colors_referenceRowBackground"
      />
    </div>
  </div>
</template>
